import type { ComparisonFilters } from "../../domain/insights/comparison-types.js";

export type RivalryCalendarSelection = {
  period: "current" | "year" | "all";
  year?: number;
  ledger: "main" | "simulator";
};

export const defaultRivalryCalendar: RivalryCalendarSelection = {
  period: "current",
  ledger: "main",
};

/** One reporting clock for both viewers; played years come from each round. */
export function reportingCalendarYear(now = new Date()): number {
  return now.getUTCFullYear();
}

export function readRivalryCalendar(
  search: string,
): RivalryCalendarSelection | null {
  const query = new URLSearchParams(search);
  if (!query.has("period") && !query.has("year") && !query.has("ledger"))
    return null;
  const ledger = query.get("ledger") === "simulator" ? "simulator" : "main";
  if (query.get("period") === "all") return { period: "all", ledger };
  if (query.get("period") === "current") return { period: "current", ledger };
  const year = Number(query.get("year"));
  if (Number.isInteger(year) && year >= 1900 && year <= 9999)
    return { period: "year", year, ledger };
  return { period: "current", ledger };
}

export function rivalryCalendarFilters(
  selection: RivalryCalendarSelection,
  currentYear = reportingCalendarYear(),
): ComparisonFilters {
  return selection.period === "all"
    ? { period: "all", ledger: selection.ledger }
    : {
        period: "year",
        year:
          selection.period === "current"
            ? currentYear
            : (selection.year ?? currentYear),
        ledger: selection.ledger,
      };
}

export function writeRivalryCalendar(
  query: URLSearchParams,
  selection: RivalryCalendarSelection,
): void {
  query.set("period", selection.period);
  query.set("ledger", selection.ledger);
  if (selection.period === "year" && selection.year)
    query.set("year", String(selection.year));
  else query.delete("year");
}

export function comparisonAnalyticsLabel(filters: ComparisonFilters): string {
  const environment =
    filters.environment ??
    (filters.ledger === "simulator" ? "simulator" : "outdoor");
  const label =
    environment === "simulator"
      ? "Simulator"
      : environment === "unknown"
        ? "Unknown environment"
        : "Outdoor";
  return `${label} · ${filters.period === "year" ? filters.year : "All Time"}`;
}
